module.exports = __webpack_public_path__ + "img/pro_one_2.fad63943.jpg";